import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Notifications3, {notify} from 'react-notify-toast';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class ContractForm extends Component{
    constructor(props){
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            contract:null
        }
    }

    componentDidMount(){
        const blocksFromHTML = convertFromHTML(this.props.contract.contract);
        const state = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        );
        this.setState({
            editorState: EditorState.createWithContent(state),
            contract:this.props.contract
        })
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            editorState
        }, ()=>{this.props.updateContract(stateToHTML(editorState.getCurrentContent()))});
    }


    render(){
        if (!this.props.contract) return <div className="alert alert-info">Loading Booking Contract...</div>;
        const {editorState} = this.state;
        const {saveHandler} = this.props;
        return (
        <React.Fragment>
            <div className="card card-body form-type-combine">
                <Editor
                    editorState={editorState}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    onEditorStateChange={this.onEditorStateChange}
                />
            </div>
            <footer className="card-footer text-right">
                <button className="btn btn-secondary" type="reset">Cancel</button>
                <button className="btn btn-primary" type="submit" onClick={saveHandler}>Submit</button>
            </footer>
        </React.Fragment>
        )
    }
}

class DetailForm extends Component{
    constructor(props){
        super(props);
    }

    render(){
        if (!this.props.bt) return <div className="alert alert-info">Loading Booking Details...</div>;
        const {bt, handleInputChange, bus_lineitem_list} = this.props;
        return (
        <React.Fragment>
        <div className="form-groups-attached">
            <div className="row">
                <div className="form-group col-12">
                    <label>Title</label>
                    <input className="form-control" name="title" type="text" onChange={handleInputChange} value={bt.title}/>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-12">
                    <label>Inquiry Welcome Message</label>
                    <textarea className="form-control" name="welcome_message" onChange={handleInputChange} value={bt.welcome_message}/>
                    <small className="form-text text-hint">This is the message a client will see when they begin building their inquiry.</small>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-12">
                    <label>Inquiry Cart Disclaimer Message</label>
                    <textarea className="form-control" name="cart_disclaimer" onChange={handleInputChange} value={bt.cart_disclaimer}/>
                    <small className="form-text text-hint">This is the message a client will see at the bottom of their cart.</small>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-12">
                    <label>Proposal/Invoice Disclaimer</label>
                    <textarea className="form-control" name="default_proposal_note" onChange={handleInputChange} value={bt.default_proposal_note}/>
                    <small className="form-text text-hint">This message will appear at the bottom of the proposal and invoice.  Add any disclaimer information you wish.</small>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-12 pt-20">
                    <div className="custom-control custom-checkbox">
                        <input type="checkbox" className="custom-control-input" name="deposit_required" id="cc-1" checked={bt.deposit_required} onChange={handleInputChange}/>
                        <label className="custom-control-label" htmlFor="cc-1">Deposit is Required</label>
                        <small className="form-text text-hint">If you require a deposit check this box and select the deposit line item and configure when the deposit is due.</small>
                    </div>
                    <div className={bt.deposit_required ? "form-group mt-20" : "d-none"}>
                        <label>Deposit Line Item</label>
                        <select className="form-control" name="bus_lineitem_id" onChange={handleInputChange} value={bt.bus_lineitem_id}>
                        {bus_lineitem_list.map((lineitem, index)=>
                            <option key={index} value={lineitem.id}>{lineitem.description}</option>
                        )}
                        </select>
                        <small className="form-text text-hint">Make sure you have a line item created for your deposit, then select it.</small>
                    </div>
                    <div className={bt.deposit_required ? "form-group" : "d-none"}>
                        <label>Deposit Due</label>
                        <select className="form-control" name="deposit_due_type" onChange={handleInputChange} value={bt.deposit_due_type}>
                        {bt.deposit_due.map((tuple, index)=>
                            <option key={index} value={tuple[0]}>{tuple[1]}</option>
                        )}
                        </select>
                        <small className="form-text text-hint">Choose whether the deposit is due 'X' days after booking or before the day of the event.</small>
                    </div>
                    <div className={bt.deposit_required ? "form-group mb-10" : "d-none"}>
                        <label>Deposit Due In</label>
                        <input className="form-control" name="deposit_due_num" type="text" onChange={handleInputChange} value={bt.deposit_due_num}/>
                        <small className="form-text text-hint">Enter the number of days after the booking or before the day of the event.  Please enter a whole number.</small>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-12 pt-10">
                    <div className="custom-control custom-checkbox">
                        <input type="checkbox" className="custom-control-input" id="cc-2" name="auto_gratuity" checked={bt.auto_gratuity} onChange={handleInputChange}/>
                        <label className="custom-control-label" htmlFor="cc-2">Automatically add Gratuity</label>
                        <small className="form-text text-hint">If you want to Automatically add Gratuity, select the lineitem below. If this value is selected gratuity will be added automatically to the proposal. You can add a Gratuity line item in the Services/Line Items area</small>
                    </div>
                    <div className={bt.auto_gratuity ? "form-group mt-20" : "d-none"}>
                        <label>Gratuity Line Item</label>
                        <select className="form-control" name="gratuity_bus_lineitem_id" onChange={handleInputChange} value={bt.gratuity_bus_lineitem_id}>
                        {bus_lineitem_list.map((lineitem, index)=>
                            <option key={index} value={lineitem.id}>{lineitem.description}</option>
                        )}
                        </select>
                        <small className="form-text text-hint">Make sure you have a line item created for your gratuity, then select it.</small>
                    </div>
                </div>
            </div>
        </div>
        </React.Fragment>
        );
    }
}


@inject('userStore')
class SettingsBooking extends Component {
    constructor(props){
        super(props);
        this.state = {
            business:null,
            bus_book_type:null,
            contract:null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.saveBookType = this.saveBookType.bind(this);
        this.fetchBooktype = this.fetchBooktype.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
    }

    componentDidMount(){
        this.setState({
            business:this.props.business
        }, () => {this.fetchBooktype()});
    }

    onEditorStateChange(){

    }

    handleInputChange(e) {
        let updated_bt = Object.assign({}, this.state.bus_book_type);
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        updated_bt[e.target.name] = value;
        console.log(updated_bt)
        this.setState({bus_book_type:updated_bt});
        //
        // let updatedSelectedItem = Object.assign({}, this.state.selectedItem);
        // this.setState({selectedItem:updatedSelectedItem});
    }


    fetchBooktype(){
        if (this.state.business){
            post('/v2/get/bus_book_type', {business_hash_id:this.state.business.hash_id},{
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                if (res.data.errors === 0){
                    this.setState({bus_book_type:res.data.bus_book_type_list[0], contract:res.data.bus_book_type_list[0].contract});
                } else {
                    notify.show(res.data.message, "error", 3000);
                }
            }).catch((error) => {
                notify.show(error, "error", 3000);
                console.log(error);
                return error;
            });
        }
    }

    updateContract = (updatedContractHTML) => {
        let contract = Object.assign({}, this.state.contract);
        contract.contract = updatedContractHTML;
        this.setState({
            contract:contract
        })
    }

    saveContract = () => {
        console.log(this.state.contract.contract);
        post('/v2/save/contract', {item:this.state.contract},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                notify.show(res.data.message, "success", 1000);
            } else {
                notify.show(res.data.message, "error", 1000);
            }
        }).catch((error) => {
            notify.show(error, "error", 1000);
            console.log(error);
            return error;
        });
    }

    saveBookType(){
        let bus_book_type = Object.assign({}, this.state.bus_book_type);
        delete bus_book_type["contract"];
        delete bus_book_type["bus_lineitem"];
        delete bus_book_type["deposit_due"];
        delete bus_book_type["business"];
        delete bus_book_type["bus_book_type_date_list"];

        post('/v2/save/bus_book_type', {item:bus_book_type},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                notify.show(res.data.message, "success", 1000);
            } else {
                notify.show(res.data.message, "error", 1000);
            }
        }).catch((error) => {
            notify.show(error, "error", 1000);
            console.log(error);
            return error;
        });
    }

    render(){
        if (!this.state.business) return <div className="alert alert-info">Loading...</div>;
        return (
        <React.Fragment>
        <Notifications3 options={{wrapperId:'booking-notifications'}}/>
        <div className="card">
            <ul className="nav nav-tabs nav-tabs-danger nav-justified" role="tablist">
                <li className="nav-item">
                    <a className="nav-link active" data-toggle="tab" href="#detail" role="tab">Detail</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#contract" role="tab">Contract</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#customdates" role="tab">Custom Dates</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#links" role="tab">Links</a>
                </li>
            </ul>
            <div className="tab-content">
                <div className="tab-pane fade active show" id="detail">
                    <div className="card card-body form-type-combine mb-0">
                        <p className="lead">These are the details a client will see when they book an event with you.  The title will appear on the inquiry, proposal and invoice.  Configure whether a deposit is required and whether gratuity is added automatically.  Make sure you have created line items that can be selected for deposit and gratuity.</p>
                        <DetailForm bt={this.state.bus_book_type} bus_lineitem_list={this.state.business.bus_lineitem_list} handleInputChange={this.handleInputChange}/>
                        <footer className="card-footer text-right">
                            <button className="btn btn-secondary" type="reset">Cancel</button>
                            <button className="btn btn-primary" type="submit" onClick={this.saveBookType}>Submit</button>
                        </footer>
                    </div>
                </div>
                <div className="tab-pane fade" id="contract">
                    {this.state.contract ?
                        <ContractForm contract={this.state.contract} saveHandler={this.saveContract} updateContract={this.updateContract}/>
                    : null}
                </div>
                <div className="tab-pane fade" id="customdates">
                    <div className="card card-body">
                    {this.state.bus_book_type ?
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Moniker</th>
                                    <th>Number of Days</th>
                                    <th>Direction</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.state.bus_book_type.bus_book_type_date_list.map((bus_book_type_date, index)=>
                                <tr key={index}>
                                  <td className="v-align-middle">{bus_book_type_date.name}</td>
                                  <td className="v-align-middle">{bus_book_type_date.due_num}</td>
                                  <td className="v-align-middle">{bus_book_type_date.due_direction}</td>
                                  <td className="v-align-middle">{bus_book_type_date.due_basedon_date}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    : null}
                    </div>
                </div>
                <div className="tab-pane fade" id="links">
                    <div className="card card-body">
                    {this.state.bus_book_type ?
                        <React.Fragment>
                        <h5>Your Booking Link</h5>
                        <p>This is the link to your inquiry builder for <strong>{this.state.bus_book_type.title}</strong>.  Ways you could use this link include:  sending directly to a perspective client in an email, sending to your web developer to include on your website, including in your email signature, adding to social media e.g Facebook, Twitter, etc.</p>
                        <p>HTML that you can embed on your site, social media, emails:</p>
                        <pre className=" language-markup">
                            <code className=" language-markup">
                                <code>&lt;a href="{this.state.bus_book_type.booking_url}"&gt;{this.state.bus_book_type.title}&lt;/a&gt;</code>
                            </code>
                            <br/><br/><strong>Which produces:</strong><br/>
                            <a href={this.state.bus_book_type.booking_url}>{this.state.bus_book_type.title}</a>
                        </pre>
                        <p>Or raw URL to provide your developer:</p>
                        <pre className=" language-markup">
                            <code className=" language-markup">
                                {this.state.bus_book_type.booking_url}
                            </code>
                        </pre>
                        </React.Fragment>
                    : null}
                    </div>
                </div>
            </div>
        </div>
        </React.Fragment>
        );
    }
}

export default SettingsBooking;



// WEBPACK FOOTER //
// ./src/components/business/SettingsBooking.js